// O'zbek lotin yozuvidan kirill yozuviga avtomatik o'girish.
//
// NIMA UCHUN TARJIMA EMAS, O'GIRISH: o'zbekcha kirill matn lotin matnning
// o'zi, faqat boshqa harflarda. Alohida lug'at yuritilsa, lotin matn
// o'zgarganda kirill nusxa eskirib qolardi. O'girish esa har doim lotin
// matndan hosil bo'ladi.
//
// ⚠️ BU FAYL NUSXA — ASLI: utils/kirill.js (server)
// Create React App src/ dan tashqaridagi faylni import qila olmaydi,
// shuning uchun nusxa. Ikkalasi bir xilligini scripts/til-sinov.js
// tekshiradi — birini o'zgartirsangiz ikkinchisini ham yangilang.

// Lotin yozuvida qolishi kerak bo'lgan so'zlar: xalqaro qisqartmalar va
// nomlar. Ular kirillda ham lotincha yoziladi.
const LOTIN_QOLSIN = new Set([
  'GPS', 'PDF', 'SMS', 'SOS', 'API', 'URL', 'JSON', 'ID', 'IP', 'SHA',
  'E-IMZO', 'LiveKit', 'Android', 'iOS', 'Google', 'Telegram', 'YouTube',
  'Firebase', 'WiFi', 'Wi-Fi', 'QR', 'PIN', 'OK', 'A4', 'Excel', 'Word',
  'fake',
]);

// Rus tilidan o'zlashgan so'zlar lotinda "ц", "ь", "я" siz yoziladi va
// harfma-harf o'girib bo'lmaydi (sentabr -> сентябр, sudya -> судья).
// So'z BOSHIDA qidiriladi, qo'shimchalar o'girilaveradi (sudyaga -> судьяга).
// "-tsiya" va "-ksiya" alohida qoida bilan o'giriladi (pastda).
const ISTISNO = [
  ['korrupsiya', 'коррупция'], ['korrupsion', 'коррупцион'],
  ['stansiya', 'станция'], ['sentabr', 'сентябр'], ['oktabr', 'октябр'],
  ['kalkulyator', 'калькулятор'], ['kompyuter', 'компьютер'], ['sudya', 'судья'],
];

const HARF = {
  a: 'а', b: 'б', d: 'д', f: 'ф', g: 'г', h: 'ҳ', i: 'и', j: 'ж', k: 'к',
  l: 'л', m: 'м', n: 'н', o: 'о', p: 'п', q: 'қ', r: 'р', s: 'с', t: 'т',
  u: 'у', v: 'в', x: 'х', y: 'й', z: 'з', c: 'с', w: 'в',
};

// Tutuq belgisining barcha ko'rinishlari: ' ʻ ʼ ’ `
const TUTUQ = "'ʻʼ’`";
const tutuqmi = (c) => c !== undefined && TUTUQ.includes(c);
const unlimi = (c) => c !== undefined && 'aeiouAEIOUўЎ'.includes(c);

// Katta-kichikligini asl harfga moslaydi. `butun` — so'z to'liq katta
// harflardami (SHAHAR -> ШАҲАР, lekin Shahar -> Шаҳар).
const moslash = (kirillHarf, asl, butunKatta) => {
  if (asl === asl.toUpperCase() && asl !== asl.toLowerCase()) {
    return butunKatta ? kirillHarf.toUpperCase()
      : kirillHarf.charAt(0).toUpperCase() + kirillHarf.slice(1);
  }
  return kirillHarf;
};

const soz = (w) => {
  if (LOTIN_QOLSIN.has(w) || /\d/.test(w)) return w;

  const harflar = w.replace(new RegExp(`[${TUTUQ}]`, 'g'), '');
  const butunKatta = harflar.length > 1 && harflar === harflar.toUpperCase();

  let natija = '';
  let i = 0;
  // Oldingi CHIQARILGAN harf unlimi — "e" ni "э" qilish uchun kerak.
  let oldingiUnli = false;

  const kichikSoz = w.toLowerCase();
  const istisno = ISTISNO.find(([l]) => kichikSoz.startsWith(l));
  if (istisno) {
    natija = moslash(istisno[1], w[0], butunKatta);
    i = istisno[0].length;
    oldingiUnli = unlimi(istisno[0].slice(-1));
  }

  while (i < w.length) {
    const c = w[i];
    const kichik = c.toLowerCase();
    const keyingi = w[i + 1];
    const keyingiKichik = keyingi?.toLowerCase();
    const sozBoshi = i === 0 || (tutuqmi(w[i - 1]) && i === 1);

    // o' -> ў, g' -> ғ
    if ((kichik === 'o' || kichik === 'g') && tutuqmi(keyingi)) {
      natija += moslash(kichik === 'o' ? 'ў' : 'ғ', c, butunKatta);
      oldingiUnli = kichik === 'o';
      i += 2;
      continue;
    }
    // s'h -> сҳ (tutuq bu yerda "sh" emasligini bildiradi)
    if (kichik === 's' && tutuqmi(keyingi) && w[i + 2]?.toLowerCase() === 'h') {
      natija += moslash('с', c, butunKatta) + moslash('ҳ', w[i + 2], butunKatta);
      oldingiUnli = false;
      i += 3;
      continue;
    }
    // probatsiya -> пробация, reaksiya -> реакция. O'zbek so'zida "ts" ham
    // uchraydi (ketsa, aytsin), shuning uchun faqat "-iya"/"-ion" oldidan.
    if (kichik === 't' && keyingiKichik === 's' && /^i(ya|on)/i.test(w.slice(i + 2))) {
      natija += moslash('ц', c, butunKatta); oldingiUnli = false; i += 2; continue;
    }
    if (kichik === 'k' && keyingiKichik === 's' && /^iya/i.test(w.slice(i + 2))) {
      natija += moslash('к', c, butunKatta) + moslash('ц', keyingi, butunKatta);
      oldingiUnli = false; i += 2; continue;
    }
    if (kichik === 's' && keyingiKichik === 'h') {
      natija += moslash('ш', c, butunKatta); oldingiUnli = false; i += 2; continue;
    }
    if (kichik === 'c' && keyingiKichik === 'h') {
      natija += moslash('ч', c, butunKatta); oldingiUnli = false; i += 2; continue;
    }
    // yo -> ё, lekin yo' -> йў (yo'q -> йўқ, yoz -> ёз)
    if (kichik === 'y' && ['o', 'u', 'a'].includes(keyingiKichik)
        && !(keyingiKichik === 'o' && tutuqmi(w[i + 2]))) {
      const k = { o: 'ё', u: 'ю', a: 'я' }[keyingiKichik];
      natija += moslash(k, c, butunKatta); oldingiUnli = true; i += 2; continue;
    }
    // ye -> е (so'z boshida yoki unlidan keyin: yer -> ер)
    if (kichik === 'y' && keyingiKichik === 'e' && (sozBoshi || oldingiUnli)) {
      natija += moslash('е', c, butunKatta); oldingiUnli = true; i += 2; continue;
    }
    if (kichik === 'e') {
      // So'z boshida va unlidan keyin "э": ekran -> экран, poeziya -> поэзия
      natija += moslash(sozBoshi || oldingiUnli ? 'э' : 'е', c, butunKatta);
      oldingiUnli = true;
      i += 1;
      continue;
    }
    if (tutuqmi(c)) {
      // So'z ichidagi tutuq belgisi -> ъ (ma'lumot -> маълумот).
      // So'z boshi yoki oxiridagisi — qo'shtirnoq, o'zgarmaydi.
      const ichida = i > 0 && i < w.length - 1;
      natija += ichida ? 'ъ' : c;
      oldingiUnli = false;
      i += 1;
      continue;
    }
    if (HARF[kichik]) {
      natija += moslash(HARF[kichik], c, butunKatta);
      oldingiUnli = unlimi(kichik);
      i += 1;
      continue;
    }
    natija += c;
    oldingiUnli = false;
    i += 1;
  }
  return natija;
};

// {o'zgaruvchi} joy tutuvchilari, havolalar, e-pochta va HTML teglari
// o'girilmaydi: ular matn emas, kod.
const HIMOYA = /(\{[^{}]*\}|https?:\/\/[^\s]+|[\w.+-]+@[\w-]+\.[\w.]+|<[^>]*>|&[a-z]+;|E-IMZO|Wi-Fi|\.(?:docx?|xlsx?|pdf|png|jpe?g|csv|txt|zip)\b)/g;

const kirill = (matn) => {
  if (typeof matn !== 'string' || !matn) return matn;
  return matn.split(HIMOYA).map((bolak, n) => {
    if (n % 2 === 1) return bolak; // himoyalangan bo'lak
    return bolak.replace(new RegExp(`[A-Za-z0-9${TUTUQ}]+(?:-[A-Za-z0-9]+)*`, 'g'), (w) => {
      if (LOTIN_QOLSIN.has(w)) return w;
      // Qisqartma yoki nomga qo'shimcha qo'shilgan: GPSsiz -> GPSсиз,
      // YouTube'da -> YouTube'да. Nomning o'zi lotincha qoladi.
      for (const q of LOTIN_QOLSIN) {
        if (!w.startsWith(q) || w.length === q.length) continue;
        const qoldiq = w.slice(q.length);
        if (tutuqmi(qoldiq[0])) return q + qoldiq[0] + kirill(qoldiq.slice(1));
        if (q === q.toUpperCase() && /^[a-z]/.test(qoldiq)) return q + kirill(qoldiq);
      }
      // Chiziqcha bilan bog'langan so'zlar (Toshkent-Termiz) alohida o'giriladi.
      return w.split('-').map(soz).join('-');
    });
  }).join('');
};

export { kirill };
